import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiFactorAuthenticationModalComponent } from './multi-factor-authentication-modal.component';
import { ButtonModule, ToggleModule } from '@xref/xref-lib';

@NgModule({
  declarations: [MultiFactorAuthenticationModalComponent],
  imports: [
    CommonModule,
    ButtonModule,
    ToggleModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  exports: [MultiFactorAuthenticationModalComponent]
})
export class MultiFactorAuthenticationModalModule { }

